import { useTranslation } from 'react-i18next';
import Styles from '../../AddGroupUsersModal/AddGroupUsersMoal.module.css';
import ChatStyles from '../../../Chat.module.css';

const GroupHeader = ({ adminControl, groupName, nameEdit, setNameEdit, inputGrouNameValue, setInputGrouNameValue, handleNameChange, onClose }) => {
  const { t } = useTranslation();
  return (
    <div className={Styles.modalHeader}>
      <div className={Styles.modalHeaderLeft}>
        <div className={Styles.modalIconBg}>
          <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
            <circle cx='9' cy='7' r='4' />
            <path d='M23 21v-2a4 4 0 0 0-3-3.87' />
            <path d='M16 3.13a4 4 0 0 1 0 7.75' />
          </svg>
        </div>
        {adminControl ? (
          !nameEdit ? (
            <>
              <span className={Styles.modalTitle}>{groupName}</span>
              <button className={ChatStyles.newChatBtn} title={t('screens.chat.editGroupName')} onClick={() => setNameEdit(true)}>
                <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z' />
                </svg>
              </button>
            </>
          ) : (
            <>
              <div className={Styles.nameSection} style={{ padding: 0 }}>
                <input
                  autoFocus
                  className={Styles.nameInput}
                  placeholder={t('screens.chat.groupNamePh')}
                  value={inputGrouNameValue}
                  onChange={e => setInputGrouNameValue(e.target.value)}
                />
              </div>
              {inputGrouNameValue.length > 0 && (
                <button className={Styles.closeBtn} onClick={() => handleNameChange()}>
                  <svg style={{ height: '1.5rem', width: '1.5rem' }}>
                    <use xlinkHref={`/assets/sprite.svg#icon-check-alt`} />
                  </svg>
                </button>
              )}
            </>
          )
        ) : (
          <span className={Styles.modalTitle}>{t('screens.chat.groupInformation')}</span>
        )}
      </div>
      <button className={Styles.closeBtn} onClick={onClose} title={t('screens.chat.close')}>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
          <line x1='18' y1='6' x2='6' y2='18' />
          <line x1='6' y1='6' x2='18' y2='18' />
        </svg>
      </button>
    </div>
  );
};

export default GroupHeader;
